import { useAsync } from 'react-use';

import { commonTranslationKeys } from '@dreryk/react-common';
import { componentsTranslationKeys, LoaderSpinner, ModalConfirmingExit, ModalWidth } from '@dreryk/react-components';

import { serviceProvidingLocationTranslationKeys } from '../../../translations';
import { HealthcarePracticeFormBean } from '../common/healthcarePractice';
import { ServiceProvidingLocationFormBean } from '../common/serviceProvidingLocation';

import { ServiceProvidingLocationUpdateForm } from './form/ServiceProvidingLocationUpdateForm';
import { useServiceProvidingLocationUpdateModalDirtyState } from './ServiceProvidingLocationUpdateModal.state';

type ServiceProvidingLocationUpdateModalProps = {
   readonly onClose: () => void;
   readonly onUpdate: (formData: ServiceProvidingLocationFormBean) => Promise<void>;
   readonly prepareInitialData: () => Promise<ServiceProvidingLocationFormBean>;
   readonly healthcarePractice: HealthcarePracticeFormBean;
};

export const ServiceProvidingLocationUpdateModal = (props: ServiceProvidingLocationUpdateModalProps): JSX.Element => {
   const shouldConfirmingExit = useServiceProvidingLocationUpdateModalDirtyState();
   const { value: serviceProvidingLocation } = useAsync(props.prepareInitialData);

   return (
      <ModalConfirmingExit
         testId={'updateServiceProvidingLocationUpdate'}
         title={serviceProvidingLocationTranslationKeys.updateServiceProvidingLocationData}
         onCancel={props.onClose}
         onCloseRequest={props.onClose}
         exitConfirmationTitle={componentsTranslationKeys.leaveForm}
         exitConfirmationMessage={componentsTranslationKeys.formLeavingConfirmation}
         shouldConfirm={shouldConfirmingExit}
         visible
         animateVisibility
         confirmationButtonLabel={commonTranslationKeys.save}
         width={ModalWidth.WIDE}
      >
         {serviceProvidingLocation ? (
            <ServiceProvidingLocationUpdateForm
               healthcarePractice={props.healthcarePractice}
               serviceProvidingLocation={serviceProvidingLocation}
               onUpdate={props.onUpdate}
            />
         ) : (
            <LoaderSpinner />
         )}
      </ModalConfirmingExit>
   );
};
